import React, { useEffect, useRef, useState } from "react";
import { CollapseWrapper, ShowButton } from "./styled";

const Collapse = ({ children }) => {
  const [isCollapse, setCollapse] = useState(true);
  const [isShowButton, setShowButton] = useState(true);
  const [widthMouted, setMoutedWidth] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (widthMouted) return;
    if (ref.current && ref.current.clientHeight < 60) {
      setShowButton(false);
      setMoutedWidth(true);
    } else {
      setCollapse(false);
      setMoutedWidth(true);
    }
  }, [ref.current]);

  return (
    <>
      <div ref={ref}>
        <CollapseWrapper isCollapse={isCollapse}>{children}</CollapseWrapper>
      </div>
      {isShowButton && (
        <ShowButton onClick={() => setCollapse(!isCollapse)}>{isCollapse ? <>Show less</> : <>Show more</>}</ShowButton>
      )}
    </>
  );
};

export default Collapse;
